import {
	addressValidation,
	matchesAddressRegex,
	matchesRegex,
	minLength,
	maxLength,
} from "./validation";

export { addressValidation, matchesAddressRegex, minLength, maxLength };

export const applyValidatorsIf =
	predicate => validators => (value, allValues) =>
		predicate(value, allValues) &&
		validators
			.map(validator => validator(value, allValues))
			.find(validationResult => !!validationResult);

export const required = value => (value ? null : `Required`);

export const minLength5 = minLength(5);

export const phoneMinLength8 = minLength(8, `Must be 7 digits or more`);

export const maxPhoneLength = max => value => {
	const withoutPlus = value?.replace(/[+]/g, "");
	if (!withoutPlus) return undefined;

	return withoutPlus?.length <= max
		? undefined
		: `Must be ${max} characters or less`;
};

export const maxLength9 = maxLength(9);

export const maxPhoneLength15 = maxPhoneLength(15);

export const maxLength50 = maxLength(50);

export const onlyDigits = value =>
	/^[0-9]*$/.test(value) ? undefined : `Only digits are allowed`;

export const matchesNameRegex = matchesRegex(
	/^[a-zA-Z0-9&!#,.'()_\-+%\d\s]*$/i,
	`Allowed characters are: alphanumeric, space and &!#,.'()_-+%`,
);

export const matchesUsernameRegex = matchesRegex(
	/^[0-9a-z@&\-_.]*$/i,
	`Only latin letters, digits, dots and @, &, -, _ are allowed`,
);

export const matchesUsernameForDataIngestRegex = matchesRegex(
	/^[a-z][-a-z0-9_]*$/i,
	`Should start with a latin letter. Then only latin letters, digits, -, _ are allowed`,
);

export const matchesCityRegex = matchesRegex(
	/^[a-z\-'’\s]*$/i,
	`Only letters, dash and apostrophe are allowed`,
);

const onlyAlphaNumeric = value =>
	/^[0-9a-zA-Z]*$/.test(value)
		? undefined
		: `Only digits and letters are allowed`;

export const zipField = applyValidatorsIf(value => {
	if (!value) return;
	const res = value?.length > 0 && /^\S+$/.test(value);
	return res;
})([onlyAlphaNumeric, minLength5, maxLength9]);
